/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowUpLeft = createReactComponent("arrow-up-left", "IconArrowUpLeft", [
  ["path", { d: "M7 7l10 10", key: "svg-0" }],
  ["path", { d: "M16 7l-9 0l0 9", key: "svg-1" }]
]);

export { IconArrowUpLeft as default };
//# sourceMappingURL=IconArrowUpLeft.js.map
